import boxBG2 from '../../../asset/images/buyBonusPopup/image_frameBFG_b.png'
import imageBoxBGPopup from '../../../asset/images/buyBonusPopup/image_frameBFG_a.png'
import btn_close_normal from '../../../asset/images/buyBonusPopup/btn_closeFG_normal.png'
import btn_close_hover from '../../../asset/images/buyBonusPopup/btn_closeFG_hover.png'
import btn_close_press from '../../../asset/images/buyBonusPopup/btn_closeFG_click.png'
import btn_close_disabled from '../../../asset/images/buyBonusPopup/btn_closeFG_unable.png'
import btnMinusNormal from '../../../asset/images/buyBonusPopup/btn_minus_normal.png'
import btnMinusHover from '../../../asset/images/buyBonusPopup/btn_minus_hover.png'
import btnMinusPress from '../../../asset/images/buyBonusPopup/btn_minus_click.png'
import btnMinusDisabled from '../../../asset/images/buyBonusPopup/btn_minus_unable.png'
import btnPlusNormal from '../../../asset/images/buyBonusPopup/btn_plus_normal.png'
import btnPlusHover from '../../../asset/images/buyBonusPopup/btn_plus_hover.png'
import btnPlusPress from '../../../asset/images/buyBonusPopup/btn_plus_click.png'
import btnPlusDisabled from '../../../asset/images/buyBonusPopup/btn_plus_unable.png'
import frame from '../../../asset/images/buyBonusPopup/frame.png'

import btnCancelNormal from '../../../asset/images/buyBonusPopup/btn_cancel_normal.png'
import btnCancelHover from '../../../asset/images/buyBonusPopup/btn_cancel_hover.png'
import btnCancelClick from '../../../asset/images/buyBonusPopup/btn_cancel_click.png'
import btnCancelUnable from '../../../asset/images/buyBonusPopup/btn_cancel_unable.png'

import btnOkNormal from '../../../asset/images/buyBonusPopup/btn_ok_normal.png'
import btnOkHover from '../../../asset/images/buyBonusPopup/btn_ok_hover.png'
import btnOkClick from '../../../asset/images/buyBonusPopup/btn_ok_click.png'
import btnOkUnable from '../../../asset/images/buyBonusPopup/btn_ok_unable.png'

import btnFGAlockNormal from '../../../asset/images/buyBonusPopup/btn_buyFGA_normal.png'
import btnFGAlockHover from '../../../asset/images/buyBonusPopup/btn_buyFGA_hover.png'
import btnFGAlockPress from '../../../asset/images/buyBonusPopup/btn_buyFGA_click.png'
import btnFGAlockDisabled from '../../../asset/images/buyBonusPopup/btn_buyFGA_unable.png'

import btnFGBlockNormal from '../../../asset/images/buyBonusPopup/btn_buyFGB_normal.png'
import btnFGBlockHover from '../../../asset/images/buyBonusPopup/btn_buyFGB_hover.png'
import btnFGBlockPress from '../../../asset/images/buyBonusPopup/btn_buyFGB_click.png'
import btnFGBlockDisabled from '../../../asset/images/buyBonusPopup/btn_buyFGB_unable.png'

// === ZH-TW 語系資源 ===
import btnCancelNormalZhtw from '../../../asset/images/buyBonusPopupZhtw/btn_cancel_normal.png'
import btnCancelHoverZhtw from '../../../asset/images/buyBonusPopupZhtw/btn_cancel_hover.png'
import btnCancelClickZhtw from '../../../asset/images/buyBonusPopupZhtw/btn_cancel_click.png'
import btnCancelUnableZhtw from '../../../asset/images/buyBonusPopupZhtw/btn_cancel_unable.png'

import btnOkNormalZhtw from '../../../asset/images/buyBonusPopupZhtw/btn_ok_normal.png'
import btnOkHoverZhtw from '../../../asset/images/buyBonusPopupZhtw/btn_ok_hover.png'
import btnOkClickZhtw from '../../../asset/images/buyBonusPopupZhtw/btn_ok_click.png'
import btnOkUnableZhtw from '../../../asset/images/buyBonusPopupZhtw/btn_ok_unable.png'

import btnFGAlockNormalZhtw from '../../../asset/images/buyBonusPopupZhtw/btn_buyFGA_normal.png'
import btnFGAlockHoverZhtw from '../../../asset/images/buyBonusPopupZhtw/btn_buyFGA_hover.png'
import btnFGAlockPressZhtw from '../../../asset/images/buyBonusPopupZhtw/btn_buyFGA_click.png'
import btnFGAlockDisabledZhtw from '../../../asset/images/buyBonusPopupZhtw/btn_buyFGA_unable.png'

import btnFGBlockNormalZhtw from '../../../asset/images/buyBonusPopupZhtw/btn_buyFGB_normal.png'
import btnFGBlockHoverZhtw from '../../../asset/images/buyBonusPopupZhtw/btn_buyFGB_hover.png'
import btnFGBlockPressZhtw from '../../../asset/images/buyBonusPopupZhtw/btn_buyFGB_click.png'
import btnFGBlockDisabledZhtw from '../../../asset/images/buyBonusPopupZhtw/btn_buyFGB_unable.png'

import FGA from '../../../asset/images/buyBonusPopupZhtw/FGA.png'
import FGB from '../../../asset/images/buyBonusPopupZhtw/FGB.png'

import { Assets } from 'pixi.js'

// 定義 Buy Bonus 資源型別
type BuyBonusAssets = {
  boxBG2: string
  imageBoxBGPopup: string
  btn_close_normal: string
  btn_close_hover: string
  btn_close_press: string
  btn_close_disabled: string
  btnMinusNormal: string
  btnMinusHover: string
  btnMinusPress: string
  btnMinusDisabled: string
  btnPlusNormal: string
  btnPlusHover: string
  btnPlusPress: string
  btnPlusDisabled: string
  frame: string
  btnCancelNormal: string
  btnCancelHover: string
  btnCancelClick: string
  btnCancelUnable: string
  btnOkNormal: string
  btnOkHover: string
  btnOkClick: string
  btnOkUnable: string
  btnFGAlockNormal: string
  btnFGAlockHover: string
  btnFGAlockPress: string
  btnFGAlockDisabled: string
  btnFGBlockNormal: string
  btnFGBlockHover: string
  btnFGBlockPress: string
  btnFGBlockDisabled: string
  FGA?: string
  FGB?: string
}

// 根據語系選擇正確的資源集
function getBuyBonusAssets(lang: string): BuyBonusAssets {
  if (lang === 'ZH_TW') {
    // ZH-TW 語系：使用 zhtw 資源，沒有的則 fallback 到 default
    return {
      // 背景資源：zhtw 沒有，使用 default
      boxBG2,
      imageBoxBGPopup,

      // Close 按鈕：zhtw 沒有，使用 default
      btn_close_normal,
      btn_close_hover,
      btn_close_press,
      btn_close_disabled,

      // Plus/Minus 按鈕：zhtw 沒有，使用 default
      btnMinusNormal,
      btnMinusHover,
      btnMinusPress,
      btnMinusDisabled,
      btnPlusNormal,
      btnPlusHover,
      btnPlusPress,
      btnPlusDisabled,

      // Frame：zhtw 沒有，使用 default
      frame,

      // Cancel/OK 按鈕：使用 zhtw 版本
      btnCancelNormal: btnCancelNormalZhtw,
      btnCancelHover: btnCancelHoverZhtw,
      btnCancelClick: btnCancelClickZhtw,
      btnCancelUnable: btnCancelUnableZhtw,
      btnOkNormal: btnOkNormalZhtw,
      btnOkHover: btnOkHoverZhtw,
      btnOkClick: btnOkClickZhtw,
      btnOkUnable: btnOkUnableZhtw,

      // FGA/FGB 按鈕：使用 zhtw 版本
      btnFGAlockNormal: btnFGAlockNormalZhtw,
      btnFGAlockHover: btnFGAlockHoverZhtw,
      btnFGAlockPress: btnFGAlockPressZhtw,
      btnFGAlockDisabled: btnFGAlockDisabledZhtw,
      btnFGBlockNormal: btnFGBlockNormalZhtw,
      btnFGBlockHover: btnFGBlockHoverZhtw,
      btnFGBlockPress: btnFGBlockPressZhtw,
      btnFGBlockDisabled: btnFGBlockDisabledZhtw,

      // FGA/FGB 圖片：zhtw 特有
      FGA,
      FGB,
    }
  }

  // Default 語系：使用 default 資源
  return {
    boxBG2,
    imageBoxBGPopup,
    btn_close_normal,
    btn_close_hover,
    btn_close_press,
    btn_close_disabled,
    btnMinusNormal,
    btnMinusHover,
    btnMinusPress,
    btnMinusDisabled,
    btnPlusNormal,
    btnPlusHover,
    btnPlusPress,
    btnPlusDisabled,
    frame,
    btnCancelNormal,
    btnCancelHover,
    btnCancelClick,
    btnCancelUnable,
    btnOkNormal,
    btnOkHover,
    btnOkClick,
    btnOkUnable,
    btnFGAlockNormal,
    btnFGAlockHover,
    btnFGAlockPress,
    btnFGAlockDisabled,
    btnFGBlockNormal,
    btnFGBlockHover,
    btnFGBlockPress,
    btnFGBlockDisabled,
  }
}

export async function AddBuyBonusBundle(lang: string) {
  // 根據語系獲取正確的資源集
  const assets = getBuyBonusAssets(lang)

  const bundleAssets: Record<string, { src: string, loadParser: string }> = {
    confirmBoxBG: { src: assets.boxBG2, loadParser: 'loadTextures' },
    imageBoxBGDefault: { src: assets.imageBoxBGPopup, loadParser: 'loadTextures' },
    btnCloseNormal: { src: assets.btn_close_normal, loadParser: 'loadTextures' },
    btnCloseHover: { src: assets.btn_close_hover, loadParser: 'loadTextures' },
    btnClosePress: { src: assets.btn_close_press, loadParser: 'loadTextures' },
    btnCloseDisabled: { src: assets.btn_close_disabled, loadParser: 'loadTextures' },
    btnMinusNormal: { src: assets.btnMinusNormal, loadParser: 'loadTextures' },
    btnMinusHover: { src: assets.btnMinusHover, loadParser: 'loadTextures' },
    btnMinusPress: { src: assets.btnMinusPress, loadParser: 'loadTextures' },
    btnMinusDisabled: { src: assets.btnMinusDisabled, loadParser: 'loadTextures' },
    btnPlusNormal: { src: assets.btnPlusNormal, loadParser: 'loadTextures' },
    btnPlusHover: { src: assets.btnPlusHover, loadParser: 'loadTextures' },
    btnPlusPress: { src: assets.btnPlusPress, loadParser: 'loadTextures' },
    btnPlusDisabled: { src: assets.btnPlusDisabled, loadParser: 'loadTextures' },
    frame: { src: assets.frame, loadParser: 'loadTextures' },

    btnCancelNormal: { src: assets.btnCancelNormal, loadParser: 'loadTextures' },
    btnCancelHover: { src: assets.btnCancelHover, loadParser: 'loadTextures' },
    btnCancelClick: { src: assets.btnCancelClick, loadParser: 'loadTextures' },
    btnCancelUnable: { src: assets.btnCancelUnable, loadParser: 'loadTextures' },

    btnOkNormal: { src: assets.btnOkNormal, loadParser: 'loadTextures' },
    btnOkHover: { src: assets.btnOkHover, loadParser: 'loadTextures' },
    btnOkClick: { src: assets.btnOkClick, loadParser: 'loadTextures' },
    btnOkUnable: { src: assets.btnOkUnable, loadParser: 'loadTextures' },

    btnFGAlockNormal: { src: assets.btnFGAlockNormal, loadParser: 'loadTextures' },
    btnFGAlockHover: { src: assets.btnFGAlockHover, loadParser: 'loadTextures' },
    btnFGAlockPress: { src: assets.btnFGAlockPress, loadParser: 'loadTextures' },
    btnFGAlockDisabled: { src: assets.btnFGAlockDisabled, loadParser: 'loadTextures' },

    btnFGBlockNormal: { src: assets.btnFGBlockNormal, loadParser: 'loadTextures' },
    btnFGBlockHover: { src: assets.btnFGBlockHover, loadParser: 'loadTextures' },
    btnFGBlockPress: { src: assets.btnFGBlockPress, loadParser: 'loadTextures' },
    btnFGBlockDisabled: { src: assets.btnFGBlockDisabled, loadParser: 'loadTextures' },
  }

  // 如果 zhtw 語系有額外的 FGA/FGB 圖片，也加入 bundle
  if (assets.FGA && assets.FGB) {
    bundleAssets.FGA = { src: assets.FGA, loadParser: 'loadTextures' }
    bundleAssets.FGB = { src: assets.FGB, loadParser: 'loadTextures' }
  }

  Assets.addBundle('BuyFreeSpinPopup', bundleAssets)
  await Assets.loadBundle('BuyFreeSpinPopup')
}
